module.exports = __webpack_public_path__ + "img/tablet.1605bd5a.jpg";